import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { AdminData } from './adminData.model';
import { AdminConst } from '../const';
import { CoreService } from '../../../core/header/core.service';
import { SuscriptionAdminDialogComponent } from './suscription-dialog.component';
import { DummyComponent } from '../../../shared/dummy.component';
import { AssignAdvisorComponent } from './assign-advisor-dialog.component';
import { AdminUserCommentsComponent } from './admin-user-comments-dialog.component';

@Component({
    selector: 'convfact-admin-list',
    templateUrl: './admin-list.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})

export class AdminListComponent implements OnInit {
  userList: AdminData[] = [];
  isConsultant = false;
  readyUser: boolean = false;
  newDateText: Date;

  headerTableUsers: any[] = AdminConst.headerTableUsers;

  constructor(
    private coreService: CoreService,
    private router: Router,
    public snackBar: MatSnackBar,
    private adminService: AdminService,
    public dialog: MatDialog,
    public dummy: DummyComponent
  ) { }

  ngOnInit() {
    this.coreService.setName('Panel de administración');
    this.readyUser = false;

    this.adminService.GetUserList().then(
      data => {
        this.userList = data;
        this.readyUser = true;
      }, data => { //  error en caso de que no sea el admin
        //TODO (Josue) modificar el data devuelto para que traiga el initialmodule
        this.router.navigate(['/resume']);
      }
    );
  }

  openSuscriptionDialog(uid: string) {
    this.dialog.open(SuscriptionAdminDialogComponent, {
      data: { userUid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  ChangeUserStatus(user: AdminData) {
    user.isActivated = !user.isActivated;
    this.adminService.ChangeUserStatus(user)
      .then(response => user = response);
  }

  ChangeConsultant(user: AdminData) {
    user.isConsultant = !user.isConsultant;
    this.adminService.ChangeConsultant(user)
      .then(response => user = response);
  }

  assignAdvisor(uid: string) {
    this.dialog.open(AssignAdvisorComponent, {
      data: { userUid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  // Interacción con la tabla
  commentsAdminPanelUserClick(userId: string) {
    let textComment = "";
    const userElement = this.userList.find(x => x.userId === userId);

    if (userElement != null) {
      textComment = userElement.commentsPanelAdminCustom;
    }

    this.dialog.open(AdminUserCommentsComponent, {
      data: { userId: userId, commentText: textComment },
      width: '50%',
      height: '40%'
    })
    .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
    });

  }

  public trackByIndex(i: number) { return i; }

}
